module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Heavy.918c8789.woff2";